import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import Modal from 'components/organisms/NewModal';

const useStyles = makeStyles((theme) => ({
  imgTitle: {
    minWidth: 120,
    margin: '0 5px 5px 0',
    fontSize: 16,
  },
}));

const ImagesModal = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { modal, handleModalClose } = props;
  return (
    <>
      <Modal
        open={modal.open}
        headerOpen={false}
        confirmBtnOpen={false}
        handleClose={handleModalClose}
        cancelBtnTitle={t('확인')}
      >
        {modal.data.length === 0
          ? t('데이터가 없습니다.')
          : modal.data.map((image, i) => {
              const code = image['IMAGE_CODE'];
              let domain = 'http://img.mobon.net/ad/imgfile';
              if (
                code === '37' ||
                code === '43' ||
                code === '44' ||
                code === '45' ||
                code === '46' ||
                code === '48' ||
                code === '49' ||
                code === '50' ||
                code === '51' ||
                code === '52' ||
                image['IMG_INFO'] === '1029_222'
              ) {
                domain = 'http://img-k.mobon.net';
              }
              return (
                <div key={i} style={{ display: 'flex' }}>
                  <h6 className={classes.imgTitle}>{image['IMG_INFO']}</h6>
                  <div>
                    <img
                      src={domain + image['IMG_PATH']}
                      alt={image['IMG_INFO']}
                    />
                  </div>
                </div>
              );
            })}
      </Modal>
    </>
  );
};

export default ImagesModal;
